import React from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components';
import { Box, breakpoints } from 'dma-ui-kit';
import useBreakpoint from 'use-breakpoint';

const Container = styled(Box)`
padding: 0 12px;
max-width: 744px;
height: 350px;

@media (min-width: 768px) {
    padding: 0 24px;
    max-width: 976px;
    height: 450px;
}

@media (min-width: 1024px) {
    padding: 0 48px;
    max-width: 1250px;
    height: 650px;
}    

margin-bottom: 10px;
display: block;
`;

const YoutubeVideo = props => {
    const { attributes, relationships } = props.paragraph;
    const { breakpoint } = useBreakpoint(breakpoints);

    const opts = {
        width: '100%',
        height: '100%',
        playerVars: {
            autoplay: 0,
            playsinline: 0,
        },
    };

    // switch (breakpoint) {
    //   case "mobile":
    //     opts.playerVars.width = '100%';
    //     opts.playerVars.height = '100%';
    //     return mobile;
    //   case "tablet":
    //   case "tabletSmall":
    //     opts.playerVars.width = '100%';
    //     opts.playerVars.height = '100%';
    //     return tablet;
    //   default:
    //     opts.playerVars.width = '100%';
    //     opts.playerVars.height = '100%';
    //     return desktop;
    // }

        // height: '315',
        // width: '560',

    const { field_video_id } = attributes;

    return (
        <Container>
          <YouTube videoId={field_video_id} opts={opts} />
        </Container>
    );
};

export default YoutubeVideo;